import { NewContact } from 'model/contacts.model';
import axios from '../core/axios';
import { ApiConstants } from './api-constants';

export class ContactService {
  static getAllContacts = async (mine: boolean, params?: any) => {
    return await (
      await axios.get(
        ApiConstants.CONTACT_API.GET_ALL_CONTACTS.URL(mine) +
          ApiConstants.CONTACT_API.GET_ALL_CONTACTS.QUERY_PARAMS(params),
      )
    ).data;
  };
  static addContact = async (payload: NewContact) => {
    return await (
      await axios.post(ApiConstants.CONTACT_API.ADD_CONTACT.URL(), payload)
    ).data;
  };
  static getContactDropdowns = async () => {
    return await (
      await axios.get(ApiConstants.CONTACT_API.CONTACT_DROPDOWNS.URL())
    ).data;
  };
  static getNotes = async (contactId: string) => {
    return await (
      await axios.get(ApiConstants.CONTACT_API.GET_NOTES.URL(contactId))
    ).data;
  };
  static addNote = async (payload: {
    noteTitle: string;
    entityId: string;
    noteContent: string;
  }) => {
    return await (
      await axios.post(ApiConstants.CONTACT_API.POST_NOTE.URL(), {
        ...payload,
      })
    ).data;
  };
  static updateNote = async (payload: {
    noteTitle: string;
    noteId: string;
    noteContent: string;
  }) => {
    return await (
      await axios.patch(ApiConstants.CONTACT_API.PATCH_NOTE.URL(), {
        ...payload,
      })
    ).data;
  };
  static deleteNote = async (noteId: string) => {
    return await (
      await axios.delete(ApiConstants.CONTACT_API.DELETE_NOTE.URL(noteId))
    ).data;
  };
  static getPresigned = async (size: string, type: string, key: string) => {
    return await (
      await axios.get(ApiConstants.CONTACT_API.PRESIGNED_URL.URL(size, type, key))
    ).data;
  };
  static deleteContact = async (contactId: string) => {
    return await (
      await axios.delete(ApiConstants.CONTACT_API.DELETE_CONTACT.URL(contactId))
    ).data;
  };
  static updateContact = async (id: string, payload: NewContact) => {
    return await (
      await axios.patch(ApiConstants.CONTACT_API.EDIT_CONTACT.URL(id), {
        ...payload,
      })
    ).data;
  };
}
